import { api } from "../../../../services/api";

export default function useGetEnterprise(){
    const getEnterpriseById = async ({ids}) => {
        let enteprise = []
        try {
          let data = {
            id_client: ids,
          };
    
          const { data: response } = await api({
            method: "POST",
            url: "/source/client",
            data,
          });
          enteprise = response
          localStorage.setItem("PreviewPDFClient", JSON.stringify(response));
        } catch (err) {

        }
        return enteprise
      };
    
    return {
        getEnterpriseById
    }
}